module.exports = __webpack_public_path__ + "static/media/meeting_room.9ccdb765.jpg";